import type { RouteRecordRaw } from 'vue-router';

export const tenantChildRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'Dashboard',
    component: () => import('@/features/tenant/dashboard/pages/DashboardPage.vue'),
    meta: { menuKey: 'dashboard' },
  },
  {
    path: 'welcome',
    redirect: { name: 'Dashboard' },
  },
  {
    path: 'personal/documents',
    name: 'PersonalDocumentsList',
    component: () => import('@/features/tenant/personal/pages/PersonalDocumentsListPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: 'personal/documents/upload',
    name: 'PersonalDocumentsUpload',
    component: () => import('@/features/tenant/personal/pages/PersonalDocumentsUploadPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: 'personal/documents/:documentId',
    name: 'PersonalDocumentDetail',
    component: () => import('@/features/tenant/personal/pages/PersonalDocumentDetailPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: 'personal/documents/:documentId/review',
    name: 'PersonalDocumentReview',
    component: () => import('@/features/tenant/personal/pages/PersonalDocumentReviewPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: 'personal/settings/integrations/line',
    name: 'PersonalLineIntegration',
    component: () => import('@/features/tenant/personal/pages/PersonalLineIntegrationPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: 'personal/integrations/line/link',
    name: 'PersonalLineLinkLanding',
    component: () => import('@/features/tenant/personal/pages/PersonalLineLinkLandingPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: 'personal/integrations/line/select',
    name: 'PersonalLineWorkspaceSelect',
    component: () => import('@/features/tenant/personal/pages/PersonalLineWorkspaceSelectPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: 'personal/integrations/line/result',
    name: 'PersonalLineIntegrationResult',
    component: () => import('@/features/tenant/personal/pages/PersonalLineIntegrationResultPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: 'settings',
    name: 'Settings',
    component: () => import('@/features/tenant/settings/pages/SettingsPage.vue'),
    meta: { menuKey: 'settings' },
  },
  {
    path: 'team',
    name: 'TeamMembers',
    component: () => import('@/features/tenant/team/pages/TeamMembersPage.vue'),
    meta: { menuKey: 'team' },
  },
  {
    path: 'workspaces',
    name: 'Workspaces',
    component: () => import('@/features/tenant/workspace/pages/WorkspaceListPage.vue'),
    meta: { menuKey: 'workspace' },
  },
  {
    path: 'workspaces/:workspaceId/settings/integrations/line',
    name: 'WorkspaceLineIntegration',
    component: () => import('@/features/tenant/workspace/pages/WorkspaceLineIntegrationPage.vue'),
    meta: { requiresAuth: true, menuKey: 'workspace' },
  },
  {
    path: 'demo/line-document-intake',
    name: 'LineDocumentIntakeDemo',
    component: () => import('@/features/tenant/line-document-intake-demo/pages/LineDocumentIntakeDemoPage.vue'),
    meta: { menuKey: 'document-intake' },
  },
  {
    path: 'document-intake',
    name: 'DocumentIntakeInbox',
    component: () => import('@/features/tenant/document-intake/pages/DocumentIntakeInboxPage.vue'),
    meta: { menuKey: 'document-intake' },
  },
  {
    path: 'document-intake/upload',
    name: 'DocumentIntakeUpload',
    component: () => import('@/features/tenant/document-intake/pages/DocumentIntakeUploadPage.vue'),
    meta: { menuKey: 'document-intake' },
  },
  {
    path: 'document-intake/unassigned',
    name: 'DocumentIntakeUnassigned',
    component: () => import('@/features/tenant/document-intake/pages/DocumentIntakeUnassignedPage.vue'),
    meta: { menuKey: 'document-intake' },
  },
  {
    path: 'document-intake/duplicates',
    name: 'DocumentIntakeDuplicates',
    component: () => import('@/features/tenant/document-intake/pages/DocumentIntakeDuplicatesPage.vue'),
    meta: { menuKey: 'document-intake' },
  },
  {
    path: 'document-intake/:documentIntakeId/review',
    name: 'DocumentIntakeReview',
    component: () => import('@/features/tenant/document-intake/pages/DocumentIntakeReviewPage.vue'),
    meta: { menuKey: 'document-intake' },
  },
  {
    path: 'document-summary',
    name: 'DocumentSummary',
    component: () => import('@/features/tenant/document-summary/pages/DocumentSummaryPage.vue'),
    meta: { menuKey: 'document-summary' },
  },
  {
    path: 'accounting/books',
    name: 'AccountingBookSettings',
    component: () => import('@/features/tenant/accounting-book/pages/AccountingBookSettingsPage.vue'),
    meta: { menuKey: 'accounting-books' },
  },
  {
    path: 'accounting/accounts',
    name: 'AccountingChartOfAccounts',
    component: () => import('@/features/tenant/accounting-book/pages/AccountingChartOfAccountsPage.vue'),
    meta: { menuKey: 'chart-of-accounts' },
  },
  {
    path: 'accounting/ledger',
    name: 'Ledger',
    component: () => import('@/features/tenant/accounting-workbench/pages/LedgerPage.vue'),
    meta: { menuKey: 'ledger' },
  },
  {
    path: 'financial-reports',
    name: 'FinancialReports',
    component: () => import('@/features/tenant/financial-report/pages/FinancialReportPage.vue'),
    meta: { menuKey: 'financial-reports' },
  },
  {
    path: 'accounting/exports',
    name: 'AccountingExports',
    component: () => import('@/features/tenant/accounting-export/pages/AccountingExportsPage.vue'),
    meta: { menuKey: 'accounting-exports' },
  },
  {
    path: 'banking/accounts',
    name: 'WorkspaceBankAccounts',
    component: () => import('@/features/tenant/bank-import/pages/BankAccountSettingsPage.vue'),
    meta: { menuKey: 'bank-accounts' },
  },
  {
    path: 'banking/import',
    name: 'BankImport',
    component: () => import('@/features/tenant/bank-import/pages/BankImportPage.vue'),
    meta: { menuKey: 'bank-import' },
  },
  {
    path: 'banking/evidence',
    name: 'BankEvidence',
    component: () => import('@/features/tenant/bank-evidence/pages/BankEvidencePage.vue'),
    meta: { menuKey: 'bank-evidence' },
  },
  {
    path: 'banking/matching',
    name: 'BankMatching',
    component: () => import('@/features/tenant/bank-matching/pages/BankMatchPage.vue'),
    meta: { menuKey: 'bank-matching' },
  },
  {
    path: 'banking/reconciliation',
    name: 'BankReconciliation',
    component: () => import('@/features/tenant/bank-reconciliation/pages/PeriodReconciliationPage.vue'),
    meta: { menuKey: 'bank-reconciliation' },
  },
  {
    path: 'banking/gl-mappings',
    name: 'BankAccountGlMappings',
    redirect: (to) => ({
      path: '/banking/accounts',
      query: {
        ...to.query,
        tab: typeof to.query.tab === 'string' ? to.query.tab : 'gl-mappings',
      },
    }),
  },
  {
    path: 'accounting/receivables',
    name: 'ArApReceivables',
    component: () => import('@/features/tenant/receivable-payable/pages/ReceivablesPage.vue'),
    meta: { menuKey: 'ar-ap-receivables' },
  },
  {
    path: 'accounting/payables',
    name: 'ArApPayables',
    component: () => import('@/features/tenant/receivable-payable/pages/PayablesPage.vue'),
    meta: { menuKey: 'ar-ap-payables' },
  },
  {
    path: 'accounting/payments',
    name: 'AccountingPayments',
    component: () => import('@/features/tenant/receivable-payable/pages/PaymentsPage.vue'),
    meta: { menuKey: 'ar-ap-payments' },
  },
  {
    path: 'accounting/opening-ar-ap',
    name: 'OpeningArApMigration',
    component: () => import('@/features/tenant/receivable-payable/pages/OpeningArApMigrationPage.vue'),
    // Stage 01: dual entry under AR/AP module. Gate route by existing receivables menu
    // (already plan-enabled); page content still requires ar_ap.opening_import.read.
    meta: { menuKey: 'ar-ap-receivables' },
  },
  {
    path: 'japanese-financial-statements',
    name: 'JapaneseFinancialStatements',
    component: () => import('@/features/tenant/japanese-financial-statement/pages/JapaneseFinancialStatementPage.vue'),
    meta: { menuKey: 'japanese-financial-statements' },
  },
  {
    path: 'accounting/review-inbox',
    name: 'ReviewInbox',
    component: () => import('@/features/tenant/review/pages/ReviewInboxPage.vue'),
    meta: { menuKey: 'ledger' },
  },
  {
    path: 'organization',
    name: 'OrganizationHealth',
    component: () => import('@/features/tenant/organization-health/pages/OrganizationHealthPage.vue'),
    meta: { menuKey: 'organization-health' },
  },
  {
    path: 'employees',
    name: 'Employees',
    component: () => import('@/features/tenant/employee-management/pages/EmployeesPage.vue'),
    meta: { menuKey: 'employee-management' },
  },
  {
    path: 'employees/retired',
    name: 'RetiredEmployees',
    component: () => import('@/features/tenant/employee-management/pages/RetiredEmployeesPage.vue'),
    meta: { menuKey: 'employee-management' },
  },
  {
    path: 'employees/tags',
    name: 'EmployeeTags',
    component: () => import('@/features/tenant/employee-management/pages/EmployeeTagsPage.vue'),
    meta: { menuKey: 'employee-management' },
  },
  {
    path: 'employees/:id',
    name: 'EmployeeDetail',
    component: () => import('@/features/tenant/employee-management/pages/EmployeeDetailPage.vue'),
    meta: { menuKey: 'employee-management' },
  },
  {
    path: 'notifications',
    name: 'Notifications',
    component: () => import('@/features/tenant/notification/pages/NotificationsPage.vue'),
    meta: { menuKey: 'notifications' },
  },
  {
    path: 'feedback',
    name: 'Feedback',
    component: () => import('@/features/tenant/feedback/pages/FeedbackPage.vue'),
    meta: { menuKey: 'feedback' },
  },
  {
    path: 'forbidden',
    name: 'Forbidden',
    component: () => import('@/features/public/errors/pages/ForbiddenPage.vue'),
  },
];

export const tenantLayoutRoute: RouteRecordRaw = {
  path: '/',
  component: () => import('@/features/tenant/shell/TenantLayout.vue'),
  meta: { requiresAuth: true },
  children: tenantChildRoutes,
};
